import { render } from "./ReadMore.vue?vue&type=template&id=71706ddd&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"

import "./ReadMore.vue?vue&type=style&index=0&id=71706ddd&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71706ddd"]])

export default __exports__